import getBudgetAnalyticsReducer from "./reducers/getBudgetAnalyticsReducer";
import { combineReducers } from "redux";
import LoginReducer from "./reducers/loginReducer";
import MondayWorkspaceReducer from "./reducers/mondayWorkspaceReducer";
import GetAllPlatformReducer from "./reducers/getAllPlatformReducer";
import SignupReducer from "./reducers/signupReducer";
import ValidateSignupReducer from "./reducers/validateSignupReducer";
import RefreshTokenReducer from "./reducers/refreshTokenReducer";
import ChangePasswordReducer from "./reducers/changePasswordReducer";
import GetWorkspaceDetailsReducer from "./reducers/getWorkspaceDetailsReducer";
import CreateWorkspaceReducer from "./reducers/createWorkspaceReducer";
import SearchWorkspaceReducer from "./reducers/searchWorkspaceReducer";
import ManageWorkspaceReducer from "./reducers/manageWorkspaceReducer";
import UpdateWorkspaceReducer from "./reducers/updateWorkspaceReducer";
import SearchCustomerReducer from "./reducers/searchCustomerReducer";
import AddCustomerReducer from "./reducers/addCustomerReducer";
import UpdateCustomerReducer from "./reducers/updateCustomerReducer";
import createDepartmentReducer from "./reducers/createDepartmentReducer";
import getDepartmentDetailsReducer from "./reducers/getDepartmentDetailsReducer";
import searchDepartmentReducer from "./reducers/searchDepartmentReducer";
import updateDepartmentReducer from "./reducers/updateDepartmentReducer";
import DeleteDepartmentReducer from "./reducers/deleteDepartmentReducer";
import CreateProjectReducer from "./reducers/createProjectReducer";
import SearchProjectReducer from "./reducers/searchProjectReducer";
import CreateTeamReducer from "./reducers/createTeamReducer";
import SearchTeamReducer from "./reducers/searchTeamReducer";
import CreateTaskReducer from "./reducers/createTaskReducer";
import SearchTaskReducer from "./reducers/searchTaskReducer";
import AddMemberReducer from "./reducers/addMemberReducer";
import SearchMemberReducer from "./reducers/searchMemberReducer";
import ProjectStatusReducer from "./reducers/projectStatusReducer";
import UpdateProjectStatusReducer from "./reducers/updateProjectStatusReducer";
import ProjectTaskStatusReducer from "./reducers/projectTaskStatusReducer";
import ProjectMemberListReducer from "./reducers/projectMemberListReducer";
import MemberProjectReducer from "./reducers/memberProjectReducer";
import MemberAccessReducer from "./reducers/memberAccessReducer";
import MemberGroupsReducer from "./reducers/memberGroupsReducer";
import getProjectDetailsReducer from "./reducers/getProjectDetailsReducer";
import GetWorkspaceMemberReducer from "./reducers/getWorkSpaceMemberReducer";
import RemoveMemberReducer from "./reducers/removeMemberReducer";
import GetNonProjectMemberReducer from "./reducers/getNonProjectMemberReducer";
import UpdateMemberReducer from "./reducers/updateMemberReducer";
import UpdateDefaultFlagReducer from "./reducers/updateDefaultFlagReducer";
import GetWorkspaceListReducer from "./reducers/getWorkspaceListReducer";
import SidebarReducer from "./reducers/sidebarReducer";
import AddMemberGroupReducer from "./reducers/addMemberGroupReducer";
import GetGroupMemberReducer from "./reducers/getGroupMemberReducer";
import TaskTrackReducer from "./reducers/taskTrackReducer";
import UpdateNotesReducer from "./reducers/updateNotesReducer";
import GetNotesReducer from "./reducers/getNotesReducer";
import UpdateProjectTaskReducer from "./reducers/updateProjectTaskReducer";
import UpdateTeamMemberReducer from "./reducers/updateTeamMemberReducer";
import UpdateVisibilityReducer from "./reducers/updateVisibilityReducer";
import GetAssigneeListReducer from "./reducers/getAssigneeListReducer";
import RemoveTeamReducer from "./reducers/removeTeamReducer";
import GetGroupDropReducer from "./reducers/getGroupDropReducer";
import UpdateGroupMemberReducer from "./reducers/updateGroupReducer";
import ProjectEstimateReducer from "./reducers/projectEstimateReducer";
import UpdateRoleReducer from "./reducers/updateRoleReducer";
import UpdateSettingsReducer from "./reducers/updateSettingsReducer";
import UpdateProjectBudgetReducer from "./reducers/updateProjectBudgetReducer";
import UpdateMemberSalaryReducer from "./reducers/updateMemberSalaryReducer";
import GetTimesheetProjectListReducer from "./reducers/getTimesheetProjectListReducer";
import AddMemberTimesheetReducer from "./reducers/addMemberTimesheetReducer";
import GetMemberTimesheetReducer from "./reducers/getMemberTimesheetReducer";
import GetDepartmentListReducer from "./reducers/getDepartmentListReducer";
import GetAllCustomerListReducer from "./reducers/getAllCustomerListReducer";
import UpdateTimesheetProjectReducer from "./reducers/updateTimesheetProjectReducer";
import ReportSummaryReducer from "./reducers/reportSummaryReducer";
import ReportSummaryCsvReducer from "./reducers/reportSummaryCsvReducer";
import CreateSessionReducer from "./reducers/createSessionReducer";
import SearchSessionReducer from "./reducers/searchSessionReducer";
import DeleteSessionReducer from "./reducers/deleteSessionReducer";
import SessionStatusReducer from "./reducers/sessionStatusReducer";
import getSessionReducer from "./reducers/getSessionReducer";
import getFindObjectiveReducer from "./reducers/getfindObjectiveReducer";
import getworkspacememberOKRReducer from "./reducers/getWorkspaceMemberOKRReducer";
import CreateObjectiveOKRReducer from "./reducers/createObjectiveOKRReducer";
import ObjectiveMultiSearchReducer from "./reducers/objectiveMultisearchReducer";
import GetObjectiveReducer from "./reducers/getObjectOKRReducer";
import ValidateInviteReducer from "./reducers/validateInviteReducer";
import UpdateCustomerStatusReducer from "./reducers/updateCustomerStatusReducer";
import UpdateBillableReducer from "./reducers/updateBillableReducer";
import EditProfileReducer from "./reducers/editProfileReducer";
import AddRemindertReducer from "./reducers/addReminderReducer";
import GetReminderListReducer from "./reducers/getReminderListReducer";
import GetReportUserReducer from "./reducers/getReportUserReducer";
import ReportSummaryUsersReducer from "./reducers/reportSummaryUsersReducer";
import ReportSummaryProjectsReducer from "./reducers/reportSummaryProjectsReducer";
import ReportSummaryTasksReducer from "./reducers/reportSummartTasksReducers";
import ReportSummaryDepartmentReducer from "./reducers/reportSummaryDepartmentReducers";
import AddMemberTimetrackerReducer from "./reducers/addMemberTimetrackerReducer";
import EditMemberTimetrackerReducer from "./reducers/editMemberTimetrackerReducer";
import TimeSheetReducer from "./reducers/timeSheetReducer";
import ReportSummaryGraphsReducer from "./reducers/reportSummaryGraphsReducer";
import ChangeMemberManagerReducer from "./reducers/changeMemberManagerReducer";
import ManagerDroupDownReducer from "./reducers/managerDropDownReducer";
import AssignOtherManagerReducer from "./reducers/assignOtherManagerReducer";
import UpdateApproveStatusReducer from "./reducers/updateApproveStatusReducer";
import AddDynamicFieldReducer from "./reducers/addDynamicFieldReducer";
import UpdateFieldStatusReducer from "./reducers/updateFieldStatusReducer";
import GetDynamicFieldReducer from "./reducers/getDynamicFieldsReducer";
import SaveDynamicFieldsReducer from "./reducers/saveDynamicFieldsReducer";
import GetCustomFieldReducer from "./reducers/getCustomFieldReducer";
import UpdateDynamicFieldReducer from "./reducers/updateDynamicfieldReducer";
import SearchCustomFieldReducer from "./reducers/searchCustomFieldReducer";
import GetTaskTemplateReducer from "./reducers/getTaskTemplateReducer";
import UpdateTemplateStatusReducer from "./reducers/updateTemplateStatusReducer";
import CreateTaskTemplateReducer from "./reducers/createTaskTemplateReducer";
import GetProjectTemplateReducer from "./reducers/getProjectTemplateReducer";
import ImportTaskTemplateReducer from "./reducers/ImportTaskTemplateReducer";
import GetApprovallistReducer from "./reducers/getApprovalListReducer";
import GetCustomersReducer from "./reducers/getCustomersReducer";
import GetProjectsReducer from "./reducers/getProjectsReducer";
import CopyLastWeekTsReducer from "./reducers/copyLastWeekTsReducer";
import AddTsTemplateReducer from "./reducers/addTsTemplateReducer";
import GetTsTemplateReducer from "./reducers/getTsTemplateReducer";
import UpdateTsTemplateReducer from "./reducers/updateTsTemplateReducer";
import ActivateTemplateReducer from "./reducers/activateTemplateReducer";
import GetCurrencyReducer from "./reducers/getCurrencyReducer";
import GetInvoiceDetailsReducer from "./reducers/getInvoiceDetailsReducer";
import CreateInvoiceReducer from "./reducers/createInvoiceReducer";
import GetInvoiceSettingReducer from "./reducers/getInvoiceSettingReducer";
import SaveInvoiceSettingReducer from "./reducers/saveInvoiceSettingReducer";
import GetEmailLogReducer from "./reducers/getEmailLogReducer";
import GetSingleInvoiceDetaileReducer from "./reducers/getSingleInvoiceDetailesReducer";
import DeleteInvoiceReducer from "./reducers/deleteInvoiceReducer";
import DuplicateInvoiceReducer from "./reducers/duplicateInvoiceReducer";
import MarkUsPaidReducer from "./reducers/markUsPaidReducer";
import DownloadInvoiceReducer from "./reducers/downloadInvoiceReducer";
import RecurringDetailesReducer from "./reducers/recurringDetailesReducer";
import StopRecurringReducer from "./reducers/stopRecurringReducer";
import EditInvoiceReducer from "./reducers/editInvoiceReducer";
import UploadAttachmentReducer from "./reducers/uploadAttachmentReducer";
import ScheduleLaterReducer from "./reducers/scheduleLaterReducer";
import StopWatchReducer from "./reducers/StopWatchReducer";
import UpdateLogoReducer from "./reducers/updateLogoReducer";
import AddEmailLogReducer from "./reducers/addEmailLogReducer";
import DeleteAddAttachmentReducer from "./reducers/deleteAddAttachmentReducer";
import GetSettingInvoiceDetailesReducer from "./reducers/getSettingInvoiceDetailsReducer";
import ReportSummaryNewReducer from "./reducers/reportSummaryNewReducer";
import GenerateAttachementReducer from "./reducers/generateAttachementReducer";
import GetAllHolidayReducer from "./reducers/getAllHolidayReducer";
import CreateOrUpdateHolidayReducer from "./reducers/createOrUpdateHolidayReducer";
import HolidayGetByIdReducer from "./reducers/holidayGetByIdReducer";
import EditHolidayReducer from "./reducers/editHolidayReducer";
import GetAllPolicyReducer from "./reducers/getAllPolicyReducer";
import CreatePolicyReducer from "./reducers/createPolicyReducer";
import GetBalanceReducer from "./reducers/getBalanceReducer";
import DeletePolicyReducer from "./reducers/deletePolicyReducer";
import GetSinglePolicyDetailesReducer from "./reducers/getSinglePolicyDetailesReducer";
import EditPolicyReducer from "./reducers/editPolicyReducer";
import GetHistoryReducer from "./reducers/getHistoryReducer";
import AddBalanceReducer from "./reducers/addBalanceReducer";
import GetRequestListReducer from "./reducers/getRequestListReducer";
import GetApproversListReducer from "./reducers/getApproversListReducer";
import ChangeRequestStatusReducer from "./reducers/changeStatusReducer";
import CreateRequestTimeOffReducer from "./reducers/createRequestTimeoffReducer";
import GetPolicyListForRequestTimeOffReducer from "./reducers/getPolicyListForRequestTimeOffReducer";
import GetTimelineReducer from "./reducers/getTimelineReducer";
import ReinviteMemberReducer from "./reducers/reinviteMemberReducer";
import ResendVerficationReducer from "./reducers/resendVerificationReducer";
import EditReminderReducer from "./reducers/editReminderReducer";
import CreateCategoryReducer from "./reducers/createCategoryReducer";
import FetchCategoryReducer from "./reducers/fetchCategoryReducer";
import EditCategoryReducer from "./reducers/editCategoryReducer";
import UpdateCategoryStatusReducer from "./reducers/updateCategoryStatusReducer";
import TimeSheetDetailsReducer from "./reducers/timeSheetDetailsReducer";
import GetMemberReducer from "./reducers/getMemberReducer";
import GetApproversReducer from "./reducers/getApproversReducer";
import AssignApproversReducer from "./reducers/assignApproversReducer";
import GetCategoryReducer from "./reducers/getCategoryReducer";
import CreateExpenseReducer from "./reducers/createExpenseReducer";
import FetchExpenseReducer from "./reducers/fetchExpenseReducer";
import EditExpenseReducer from "./reducers/editExpenseReducer";
import DeleteExpenseReducer from "./reducers/deleteExpenseReducer";
import ArchieveExpenseReducer from "./reducers/archieveExpenseReducer";
import SubmitApproveReducer from "./reducers/submitApproveReducer";
import ChangeExpenseReducer from "./reducers/changeExpenseReducer";
import RemindApproveReducer from "./reducers/remindApproveReducer";
import ApprovalListV2Reducer from "./reducers/approvalListV2Reducer";
import MemberExpenseApprovalReducer from "./reducers/memberExpenseApprovalReducer";
import MemberTimeOffApprovalReducer from "./reducers/memberTimeOffApprovalReducer";
import ApproveAllReducer from "./reducers/approveAllReducer";
import RetrieveExpenseReducer from "./reducers/retrieveExpenseReducer";
import GetWorkSpaceOwnersReducer from "./reducers/getWorkSpaceOwnersReducer";
import GetObjectivesReducer from "./reducers/getObjectivesReducer";
import CreateKeyResultReducer from "./reducers/createKeyResultReducer";
import ObjectivesProjectListReducer from "./reducers/objectivesProjectListReducer";
import ObjectivesTaskListReducer from "./reducers/objectivesTaskListReducer";
import ObjectiveTaskLinkReducer from "./reducers/objectiveTaskLinkReducer";
import DeleteKeyResultReducer from "./reducers/deleteKeyResultReducer";
import ObjectiveLinkedReducer from "./reducers/objectiveLinkedReducer";
import DeleteObjectiveTaskReducer from "./reducers/deleteObjectiveTaskReducer";
import EditObjectiveReducer from "./reducers/editObjectiveReducer";
import UpdateObjectiveStatusReducer from "./reducers/updateObjectiveStatusReducer";
import DeleteObjectiveReducer from "./reducers/deleteObjectiveReducer";
import GetSessionDashboardReducer from "./reducers/getSessionDashboardReducer";
import DeleteLinkedObjectiveReducer from "./reducers/deleteLinkedObjectiveReducer";
import LinkaccessabilityReducer from "./reducers/linkaccessabilityReducer";
import okrSessionReducer from "./reducers/okrSessionReducer";
import getSideBarStatus from "./reducers/getSideBarStatusReducer";
import getOkrStatus from "./reducers/getOkrStatusReducer";
import customerSupportReducer from "./reducers/customerSupportReducer";
import languageReducer from "./reducers/languageReducer";
import stripeSubscriptionReducer from "./reducers/stripeSubscriptionReducer";
import culturalCreateCategoryReducer from "./reducers/culturalCreateCategoryReducer";
import culturalEditCategoryReducer from "./reducers/culturalEditCategoryReducer";
import cultureSubCategoryReducer from "./reducers/culturalCreateSubCategoryReducer";
import culturalEditSubCategoryReducer from "./reducers/culturalEditSubCategoryReducer";
import cultureFitGraphReducer from "./reducers/cultureFitGraphReducer";
import GetFetchAdvanceSurveyReducer from "./reducers/getfetchAdvanceSurveyReducer";
import GetculturePreBuiltTemplateReducer from "./reducers/getculturePreBuiltTemplateReducer";
import GetculturePreBuiltTemplateEditReducer from "./reducers/getculturePreBuiltTemplateEditReducer";
import CultrurePreBuiltTemplatePostReducer from "./reducers/cultrurePreBuiltTemplatePostReducer";
import WorkspaceMemberOKRReducer from "./reducers/workspaceMemberOKRReducer";
export default combineReducers({
  getBudgetAnalyticsReducer,
  MondayWorkspaceReducer,
  GetAllPlatformReducer,
  WorkspaceMemberOKRReducer,
  CultrurePreBuiltTemplatePostReducer,
  GetFetchAdvanceSurveyReducer,
  GetculturePreBuiltTemplateReducer,
  GetculturePreBuiltTemplateEditReducer,
  LoginReducer,
  SignupReducer,
  ValidateSignupReducer,
  RefreshTokenReducer,
  ChangePasswordReducer,
  GetWorkspaceDetailsReducer,
  CreateWorkspaceReducer,
  SearchWorkspaceReducer,
  ManageWorkspaceReducer,
  UpdateWorkspaceReducer,
  SearchCustomerReducer,
  AddCustomerReducer,
  UpdateCustomerReducer,
  createDepartmentReducer,
  getDepartmentDetailsReducer,
  searchDepartmentReducer,
  updateDepartmentReducer,
  DeleteDepartmentReducer,
  CreateProjectReducer,
  SearchProjectReducer,
  CreateTeamReducer,
  SearchTeamReducer,
  CreateTaskReducer,
  SearchTaskReducer,
  AddMemberReducer,
  SearchMemberReducer,
  ProjectStatusReducer,
  UpdateProjectStatusReducer,
  ProjectTaskStatusReducer,
  ProjectMemberListReducer,
  MemberProjectReducer,
  MemberAccessReducer,
  MemberGroupsReducer,
  getProjectDetailsReducer,
  GetWorkspaceMemberReducer,
  RemoveMemberReducer,
  GetNonProjectMemberReducer,
  UpdateMemberReducer,
  UpdateDefaultFlagReducer,
  GetWorkspaceListReducer,
  SidebarReducer,
  AddMemberGroupReducer,
  GetGroupMemberReducer,
  TaskTrackReducer,
  UpdateNotesReducer,
  GetNotesReducer,
  UpdateProjectTaskReducer,
  UpdateTeamMemberReducer,
  UpdateVisibilityReducer,
  GetAssigneeListReducer,
  RemoveTeamReducer,
  GetGroupDropReducer,
  UpdateGroupMemberReducer,
  ProjectEstimateReducer,
  UpdateRoleReducer,
  UpdateSettingsReducer,
  UpdateProjectBudgetReducer,
  UpdateMemberSalaryReducer,
  GetTimesheetProjectListReducer,
  AddMemberTimesheetReducer,
  GetMemberTimesheetReducer,
  GetDepartmentListReducer,
  GetAllCustomerListReducer,
  UpdateTimesheetProjectReducer,
  ReportSummaryReducer,
  ReportSummaryCsvReducer,
  CreateSessionReducer,
  SearchSessionReducer,
  DeleteSessionReducer,
  SessionStatusReducer,
  getSessionReducer,
  getFindObjectiveReducer,
  getworkspacememberOKRReducer,
  CreateObjectiveOKRReducer,
  ObjectiveMultiSearchReducer,
  GetObjectiveReducer,
  ValidateInviteReducer,
  UpdateCustomerStatusReducer,
  UpdateBillableReducer,
  EditProfileReducer,
  AddRemindertReducer,
  GetReminderListReducer,
  GetReportUserReducer,
  ReportSummaryUsersReducer,
  ReportSummaryProjectsReducer,
  ReportSummaryTasksReducer,
  ReportSummaryDepartmentReducer,
  AddMemberTimetrackerReducer,
  EditMemberTimetrackerReducer,
  TimeSheetReducer,
  ReportSummaryGraphsReducer,
  ChangeMemberManagerReducer,
  ManagerDroupDownReducer,
  AssignOtherManagerReducer,
  UpdateApproveStatusReducer,
  AddDynamicFieldReducer,
  UpdateFieldStatusReducer,
  GetDynamicFieldReducer,
  SaveDynamicFieldsReducer,
  GetCustomFieldReducer,
  UpdateDynamicFieldReducer,
  SearchCustomFieldReducer,
  GetTaskTemplateReducer,
  UpdateTemplateStatusReducer,
  CreateTaskTemplateReducer,
  GetProjectTemplateReducer,
  ImportTaskTemplateReducer,
  GetApprovallistReducer,
  GetCustomersReducer,
  GetProjectsReducer,
  CopyLastWeekTsReducer,
  AddTsTemplateReducer,
  GetTsTemplateReducer,
  UpdateTsTemplateReducer,
  ActivateTemplateReducer,
  GetCurrencyReducer,
  GetInvoiceDetailsReducer,
  CreateInvoiceReducer,
  GetInvoiceSettingReducer,
  SaveInvoiceSettingReducer,
  GetEmailLogReducer,
  GetSingleInvoiceDetaileReducer,
  DeleteInvoiceReducer,
  DuplicateInvoiceReducer,
  MarkUsPaidReducer,
  DownloadInvoiceReducer,
  RecurringDetailesReducer,
  StopRecurringReducer,
  EditInvoiceReducer,
  UploadAttachmentReducer,
  ScheduleLaterReducer,
  StopWatchReducer,
  UpdateLogoReducer,
  AddEmailLogReducer,
  DeleteAddAttachmentReducer,
  GetSettingInvoiceDetailesReducer,
  ReportSummaryNewReducer,
  GenerateAttachementReducer,
  GetAllHolidayReducer,
  CreateOrUpdateHolidayReducer,
  HolidayGetByIdReducer,
  EditHolidayReducer,
  GetAllPolicyReducer,
  CreatePolicyReducer,
  GetBalanceReducer,
  DeletePolicyReducer,
  GetSinglePolicyDetailesReducer,
  EditPolicyReducer,
  GetHistoryReducer,
  AddBalanceReducer,
  GetRequestListReducer,
  GetApproversListReducer,
  ChangeRequestStatusReducer,
  CreateRequestTimeOffReducer,
  GetPolicyListForRequestTimeOffReducer,
  GetTimelineReducer,
  ReinviteMemberReducer,
  ResendVerficationReducer,
  EditReminderReducer,
  CreateCategoryReducer,
  FetchCategoryReducer,
  EditCategoryReducer,
  UpdateCategoryStatusReducer,
  TimeSheetDetailsReducer,
  GetMemberReducer,
  GetApproversReducer,
  AssignApproversReducer,
  GetCategoryReducer,
  CreateExpenseReducer,
  FetchExpenseReducer,
  EditExpenseReducer,
  DeleteExpenseReducer,
  ArchieveExpenseReducer,
  SubmitApproveReducer,
  ChangeExpenseReducer,
  RemindApproveReducer,
  ApprovalListV2Reducer,
  MemberExpenseApprovalReducer,
  MemberTimeOffApprovalReducer,
  ApproveAllReducer,
  RetrieveExpenseReducer,
  GetWorkSpaceOwnersReducer,
  GetObjectivesReducer,
  CreateKeyResultReducer,
  ObjectivesProjectListReducer,
  ObjectivesTaskListReducer,
  ObjectiveTaskLinkReducer,
  DeleteKeyResultReducer,
  ObjectiveLinkedReducer,
  DeleteObjectiveTaskReducer,
  EditObjectiveReducer,
  UpdateObjectiveStatusReducer,
  DeleteObjectiveReducer,
  GetSessionDashboardReducer,
  DeleteLinkedObjectiveReducer,
  LinkaccessabilityReducer,
  okrSessionReducer,
  getSideBarStatus,
  getOkrStatus,
  customerSupportReducer,
  language: languageReducer,
  stripeSubscriptionReducer,
  category: culturalCreateCategoryReducer,
  categoryUpdate: culturalEditCategoryReducer,
  subCategory: cultureSubCategoryReducer,
  subCategoryUpdate: culturalEditSubCategoryReducer,
  cultureFitGraphReducer: cultureFitGraphReducer,
});
